import { render, staticRenderFns } from "./booking.vue?vue&type=template&id=dac3c24c&scoped=true&"
import script from "./booking.vue?vue&type=script&lang=js&"
export * from "./booking.vue?vue&type=script&lang=js&"
import style0 from "./booking.vue?vue&type=style&index=0&id=dac3c24c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac3c24c",
  null
  
)

export default component.exports